import React from "react";

import LimitedDataWarningBadgeView from "./LimitedDataWarningBadgeView";

/**
 *
 */
interface LimitedDataWarningBadgeContainerProps {
  show: boolean;
  isSmallScreen?: boolean;
}

/**
 * Container component that conditionally renders the limited data warning badge.
 * @param root0 - Component props
 * @param root0.show - Whether to display the badge (returns null if false)
 * @param root0.isSmallScreen - Whether the screen size is small (affects badge styling)
 */
const LimitedDataWarningBadgeContainer = ({
  show,
  isSmallScreen = false,
}: LimitedDataWarningBadgeContainerProps) => {
  if (!show) {
    return null;
  }

  return <LimitedDataWarningBadgeView isSmallScreen={isSmallScreen} />;
};

export default React.memo(LimitedDataWarningBadgeContainer);
